export default __webpack_public_path__ + "static/media/guide-p.628bbb48.svg";